import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import "./sustainabilitypage.css"

const IncentivesPage = () => {
    const { t } = useTranslation();
    const topRef = useRef();
    const midRef = useRef();

    const [isTopVisible, setIsTopVisible] = useState(false);
    const [isMidVisible, setIsMidVisible] = useState(false);

    useEffect(() => {
        const currentTopRef = topRef.current;
        const currentMidRef = midRef.current;

        const topObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsTopVisible(true);
                    topObserver.unobserve(entry.target);
                }
            });
        });

        const midObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsMidVisible(true);
                    midObserver.unobserve(entry.target);
                }
            });
        });

        if (currentTopRef) {
            topObserver.observe(currentTopRef);
        }

        if (currentMidRef) {
            midObserver.observe(currentMidRef);
        }

        return () => {
            if (currentTopRef) {
                topObserver.unobserve(currentTopRef);
            }

            if (currentMidRef) {
                midObserver.unobserve(currentMidRef);
            }
        };
    }, []);

    return (
        <div className='sustainability-main-container'>

            <div className={`sustainability-top-container relative ${isTopVisible ? "fade-in" : ""}`} ref={topRef}>
                <div className="sustainability-header-content">
                    <h1 className="homepage-title1 mb-0">{t('incentivesPage.header.title')}</h1>
                </div>
            </div>

            <div className={`sustainability-bottom-container ${isMidVisible ? "fade-in" : ""}`} ref={midRef}>

                <div className='md:grid grid-cols-2 gap-12 relative z-2'>
                    <div className=''>
                        <div className='sustainability-img2 z-4 relative'></div>
                    </div>
                    <div className="py-6">
                        <p className='homepage-text2 mb-4'>{t('incentivesPage.intro.desc1')}</p>
                        <p className='homepage-text2 mb-0'>{t('incentivesPage.intro.desc2')}</p>
                    </div>
                </div>

                <div className=" pt-16">
                    <div>
                        <h2 className="homepage-title3">{t('incentivesPage.support.title')}</h2>
                        <ul className="homepage-text2 list-disc pl-8">
                            <li>{t('incentivesPage.support.list.item1')}</li>
                            <li>{t('incentivesPage.support.list.item2')}</li>
                            <li>{t('incentivesPage.support.list.item3')}</li>
                            <li>{t('incentivesPage.support.list.item4')}</li>
                        </ul>
                    </div>

                    <div className="md:grid grid-cols-2 gap-4 mb-8">
                        <div>
                            <h2 className="homepage-title3">{t('incentivesPage.pipeline.title')}</h2>
                            <ul className="homepage-text2 list-disc pl-8">
                                <li>{t('incentivesPage.pipeline.list.item1')}</li>
                                <li>{t('incentivesPage.pipeline.list.item2')}</li>
                                <li>{t('incentivesPage.pipeline.list.item3')}</li>
                            </ul>
                        </div>
                        <div className='sustainability-img3 z-4'></div>
                    </div>

                    <div>
                        <h2 className="homepage-title3">{t('incentivesPage.news.title')}</h2>
                        <p className="homepage-text2">
                            {t('incentivesPage.news.desc')}
                            <br /> <br />
                            {t('incentivesPage.news.subtext')}
                            <ul className="homepage-text2 list-disc pl-8">
                                <li>{t('incentivesPage.news.list.item1')}</li>
                                <li>{t('incentivesPage.news.list.item2')}</li>
                                <li>{t('incentivesPage.news.list.item3')}</li>
                                <li>{t('incentivesPage.news.list.item4')}</li>
                            </ul>
                        </p>

                    </div>
                </div>

            </div>

        </div>
    )
}

export default IncentivesPage;